import { getLeFEOrigin } from '@utils/util';

export const SmsManagerLeFE = () => (
    <iframe className="admin-iframe" title="邮件发送" src={`${getLeFEOrigin()}/#/runtime/admin/sms_template`} />
);
